<template>
<section>

  <!-- {{channel}} -->


    <article class="message">
        <div class="message-header">
          
          <section>
          
            <b-field grouped>
            
              <b-field multiline>

                <span class="panel-icon" style="font-size: 1.4em;">
                    <i v-if="channel.type == 'phone'" class="fas fa-phone" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>
                    <i v-if="channel.type == 'email'" class="fas fa-envelope" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>
                    <i v-if="channel.type == 'facebook'" class="fab fa-facebook" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>
                    <i v-if="channel.type == 'skype'" class="fab fa-skype" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>            
                    <i v-if="channel.type == 'twitter'" class="fab fa-twitter" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>            
                    <i v-if="channel.type == 'address'" class="fas fa-home" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>            
                    <i v-if="channel.type == 'other'" class="fas fa-bookmark" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>            
                  </span>
              </b-field>

              <span expanded>
                {{channel.info}}
              </span>

            </b-field>
          
            <b-field grouped group-multiline>
              <div v-for="tag in channel.tags" :key="tag">
                <div style="margin:0.2em; padding:0.2em; min-width: 3em; background: green; color: white;">{{tag}}</div>
              </div>

              <!-- ATAGS FOR IMPORTED CHANNELS, eg. google -->
              <div v-for="atag in channel.atags" :key="atag">
                <!-- <div style="margin:0.2em; padding:0.2em; min-width: 3em; background: green; color: white;">{{tag}}</div> -->
                <i v-if="atag == 'google'" class="fab fa-google" style="color: green; margin-left: 0.2em; font-size:1.8em;" aria-hidden="true"></i> 
              </div>
              
              <div v-if="channel.pref">  
                <i class="fas fa-heart" style="color: green; margin-right: 1em; padding-left: 0.5em; padding-bottom: 0.5em; font-size:1.8em;" aria-hidden="true"></i>
              </div>
              <div v-if="!channel.pref">  
                <i class="far fa-heart" style="color: green; margin-right: 1em; padding-left: 0.5em; padding-bottom: 0.5em; font-size:1.8em;" aria-hidden="true"></i>
              </div>

            </b-field>
          </section>

          <!-- CLOSE BUTTON -->
          <!-- <button type="button" aria-label="delete" @keypress.prevent @click.prevent="toggleEdit"> -->

          <!-- <button type="button" aria-label="toggle" @click.prevent="onToggleEdit">

            <i class="fas fa-chevron-circle-down" style="font-size:1.8em;" v-if="!isEditActive" ></i>
            <i class="fas fa-chevron-circle-up" style="font-size:1.8em;" v-if="isEditActive" ></i>
          </button> -->

          <div aria-label="toggle" @click.prevent="onToggleEdit">
            <i class="fas fa-chevron-circle-down" style="font-size:1.8em;" v-if="!isEditActive" ></i>
            <i class="fas fa-chevron-circle-up" style="font-size:1.8em;" v-if="isEditActive" ></i>
          </div>


        </div>

        <div class="message-body" v-if="isEditActive">

            <b-field label="Type" label-position="on-border">
              <b-select placeholder="Select Type" expanded v-model="channel.type" 
                    @keypress.prevent icon="arrow-circle-right" icon-pack="fas">
                <option value="email ">Email</option>
                <option value="phone">Phone</option>
                <option value="facebook">Facebook</option>
                <option value="skype">Skype</option>
                <option value="twitter">Twitter</option>
                <option value="address">Address</option>
                <option value="other">Other</option>
              </b-select>
                <!-- <b-input type="text" placeholder="Company Name"  
                    v-model="channel.type"
                    maxlength="30">
                </b-input> -->
            </b-field>

            <b-field label="Channel" label-position="on-border">
                <b-input type="text" placeholder="Channel Info"  
                    v-model="channel.info"
                    maxlength="30">
                </b-input>
            </b-field>

            <b-field label="Preferred" position="is-centered"> 
            <div>
              <!-- Preferred >  -->
              <a class="button is-light" expanded @click="onToggleLike">
                <div v-if="channel.pref">  
                  <i class="fas fa-heart" style="color: green; font-size:2.3em;" aria-hidden="true"></i>
                </div>
                <div v-if="!channel.pref">  
                  <i class="far fa-heart" style="color: green; font-size:2.3em;" aria-hidden="true"></i>
                </div>
              </a>
            </div>
            </b-field>

            <!-- <section> -->
        <b-field label="Add some tags">
            <b-taginput
                v-model="channel.tags"
                ellipsis
                icon="label"
                placeholder="Add a tag">
            </b-taginput>
        </b-field>
        <!-- <p class="content"><b>Tags:</b> {{ channel.tags }}</p> -->
      <!-- </section> -->


          
         
          <a class="button is-light  is-right expand"  @click="onToggleEdit">
            <div>  
              <i class="fas fa-chevron-circle-up" style=" margin-right: 0.3em; font-size:1.2em;" aria-hidden="true"></i>
            </div>
            OK
          </a>

        </div>
      </article>

      
    
</section>
</template>

<script>

// import { mapGetters, mapActions } from 'vuex';
import { ListOfChannels } from '@/utils/settings'

export default {

  name: 'ListPanelItem',
  components: {
    
  },
  data() {
    return  {
      isEditActive: false,
      listOfChannels: ListOfChannels
      
    }
  },
  props: {
    channel: {},
  },
  created () {
    this.isEditActive = this.channel.type == null ? true : false
  },
  computed: {
    // isRead: this.contact.status==='read' ? true: false

  },
  methods: {
    // ...mapActions(['deleteChannel']),
    onToggleLike () {
      // console.log("toggle" + this.channel.status.c)
      this.channel.pref = !this.channel.pref
    },
    onToggleEdit () {
      // console.log("toggle" + this.channel.status.c)
      this.isEditActive = !this.isEditActive
    },
    setType () {
      this.isEditActive = true
    },
    
    
  },
  

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* .read {
    background: green;
  } */
</style>